import CustomerAdvancedView from './CustomerAdvancedView'

export default CustomerAdvancedView
